import { useState, useEffect } from 'react';
import { useShopContext } from '../../context/ShopContext';
import api from '../../api/client';
import { Theme } from '../../types';

export default function ThemesTab() {
  const { selectedStore ,themes} = useShopContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [primaryColor, setPrimaryColor] = useState('#4F46E5');
  const [secondaryColor, setSecondaryColor] = useState('#FF9900');
  const [logo, setLogo] = useState<string | null>(null);



  const handleSave = async () => {
    if (!selectedStore) {
      alert('No store selected');
      return;
    }
    try {
      setLoading(true);
      const updatedTheme = {
        primary_color: primaryColor,
        secondary_color: secondaryColor,
        logo,
      };
     
    //   setTheme({ ...updatedTheme, id: theme?.id || 0 });
    } catch (err) {
      setError('Failed to update theme');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-bold mb-6">Store Theme</h2>
      {loading && <p>Loading theme...</p>}
      {error && <p className="text-red-600">{error}</p>}
      {!selectedStore && <p>Please select a store to view its theme.</p>}
      {!loading && !error && selectedStore && (
        <form className="space-y-4 max-w-lg">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Primary Color</label>
            <input
              type="color"
              className="w-16 h-10"
              value={primaryColor}
              onChange={(e) => setPrimaryColor(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Secondary Color</label>
            <input
              type="color"
              className="w-16 h-10"
              value={secondaryColor}
              onChange={(e) => setSecondaryColor(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Logo</label>
            <input
              type="file"
              accept="image/*"
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              onChange={(e) => setLogo(e.target.files?.[0]?.name || null)}
            />
            {logo && <p className="text-sm text-gray-600 mt-1">Current logo: {logo}</p>}
          </div>
          <button
            type="button"
            className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark"
            onClick={handleSave}
          >
            Save Theme
          </button>
        </form>
      )}
    </div>
  );
}